module.exports = __webpack_public_path__ + "img/粘贴2.59dff39e.svg";